import type { ExportRow } from './csv';

/**
 * Generates JSON content from rows.
 */
export function generateJSON(rows: ExportRow[], columnIds: string[]): string {
  const filtered = rows.map((row) => Object.fromEntries(columnIds.map((id) => [id, row[id]])));
  return JSON.stringify(filtered, null, 2);
}
